(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('ComplaintFormDeleteController',ComplaintFormDeleteController);

    ComplaintFormDeleteController.$inject = ['$uibModalInstance', 'entity', 'ComplaintForm'];

    function ComplaintFormDeleteController($uibModalInstance, entity, ComplaintForm) {
        var vm = this;

        vm.complaintForm = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ComplaintForm.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
